import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, TerminalIcon, UsersIcon } from 'lucide-react';
const Hero = () => {
  return <section className="relative w-full min-h-screen bg-gradient-to-b from-white via-orange-50/30 to-white flex items-center justify-center overflow-hidden pt-16 pb-12 sm:pt-20 sm:pb-16 md:pt-24 md:pb-20" data-id="element-585">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] opacity-[0.3] pointer-events-none" data-id="element-586"></div>

      <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10 text-center" data-id="element-587">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-bold tracking-tighter text-gray-900 leading-[1.1] sm:leading-[1.05] md:leading-[0.95] mb-6 sm:mb-8" data-id="element-588">
          Agentic interfaces
          <br data-id="element-589" />
          <span className="text-gray-900" data-id="element-590">for production apps</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-500 max-w-3xl mx-auto mb-8 sm:mb-10 md:mb-12 leading-relaxed px-4 sm:px-0" data-id="element-591">
          Turn your UI into an execution surface for AI — with policies,
          approvals, and auditability built in. FluidWeb embeds AI inside your
          product's workflows so users can complete work with voice, chat, and
          files — safely, reliably, and under your control.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center mb-8 sm:mb-10 md:mb-12 px-4 sm:px-0" data-id="element-592">
          <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-orange-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-orange-600 transition-all shadow-lg shadow-orange-500/20 hover:shadow-orange-500/30 hover:-translate-y-0.5 min-h-[44px]" data-id="element-593">
            Get a demo
            <ArrowRightIcon size={20} data-id="element-594" />
          </a>
          <a href="/community" className="inline-flex items-center justify-center gap-2 bg-white text-gray-600 border border-gray-200 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-medium hover:bg-gray-50 hover:text-gray-900 transition-colors min-h-[44px]" data-id="element-595">
            <UsersIcon size={20} data-id="element-596" />
            Join Community
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm font-medium text-gray-400 uppercase tracking-widest px-4" data-id="element-597">
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-598">
            <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-599"></div>
            React SDK
          </span>
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-600">
            <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-601"></div>
            TypeScript
          </span>
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-602">
            <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-603"></div>
            Zero-config start
          </span>
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-604">
            <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-605"></div>
            Schema-first
          </span>
        </motion.div>
      </div>
    </section>;
};
export default Hero;